import React, { Component } from "react";
import { connect } from 'react-redux';
import Uppy from '@uppy/core';
import { Dashboard } from '@uppy/react';
import Swal from 'sweetalert2'
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'
import Transloadit from '@uppy/transloadit';
import GoogleDrive from '@uppy/google-drive';
import Dropbox from '@uppy/dropbox';
import Instagram from '@uppy/instagram';
import Facebook from '@uppy/facebook';
import OneDrive from '@uppy/onedrive';
import Webcam from '@uppy/webcam';
import ScreenCapture from '@uppy/screen-capture';
import ImageEditor from '@uppy/image-editor';
import Url from '@uppy/url';
import { Card, Button, Row, Col, Form } from 'react-bootstrap';
import { NavigationHeader } from "../../layout/components/navigationheader/NavigationHeader";
import { USER_STUDIO_WALL, updateRequestImage } from '../../../../../../../actions/sceneActions'
import { MEDIA_SUCCESS_SAVE, SUCCESS_TEXT } from '../../../app/messageText'
import { customClass } from '../../../../../../../utils'
import { UPPY_AWS_KEY, UPPY_AWS_SECRET_KEY, UPPY_BUCKET, UPPY_BUCKET_URL, UPPY_CAMPAION_URL, UPPY_KEY } from "../../../../../../../actions/constant";

const uppy = new Uppy({
    id: 'uppy',
    meta: { type: 'avatar' },
    autoProceed: true,
    allowMultipleUploads: true,
    debug: true,
    restrictions: {
        maxFileSize: 104857600,
        maxNumberOfFiles: 1,
        minNumberOfFiles: 1,
        allowedFileTypes: ['image/*', 'video/*']
    },
    onBeforeFileAdded: (currentFile, files) => {
        const file = uppy.getFile('uppyteamkongjpg1501851828779')
    },
    onBeforeUpload: (files) => {


    }
})

const uppyKey = UPPY_KEY;
const uppyBucket1 =  UPPY_BUCKET;
const uppyAwsKey1 =  UPPY_AWS_KEY;
const uppyAwsSecret1 =  UPPY_AWS_SECRET_KEY;
const companionUrl = UPPY_CAMPAION_URL;

uppy.use(GoogleDrive, { companionUrl: companionUrl })
uppy.use(Dropbox, { companionUrl: companionUrl })
uppy.use(Instagram, { companionUrl: companionUrl })
uppy.use(Facebook, { companionUrl: companionUrl })
uppy.use(OneDrive, { companionUrl: companionUrl })
uppy.use(Webcam, { companionUrl: companionUrl })
uppy.use(ScreenCapture, { companionUrl: companionUrl })
uppy.use(ImageEditor, { companionUrl: companionUrl })
uppy.use(Url, { companionUrl: companionUrl })
uppy.use(Transloadit, {
    params: {
        auth: {
            key: uppyKey
        },
        steps: {
            store: {
                robot: '/wasabi/store',
                bucket_region: "us-west-1",
                result: true,
                bucket: uppyBucket1,
                key: uppyAwsKey1,
                secret: uppyAwsSecret1,
                path: 'media/tmpimages/${file.id}.${file.ext}',
            }
        }
    },
    waitForEncoding: true
})

class UpdateMedia extends Component {
    state = {
        selectedFile: null,
        previewURL: null,
        selectedName: null,
        timeInterval: 0,
        buttonDis: false,
        loader: false
    }
    componentDidMount() {

        const { match, scenes, history } = this.props;
        if (scenes.updateSceneData && Object.keys(scenes.updateSceneData).length > 0) {
            this.setState({ selectedFile: scenes.updateSceneData.content, previewURL: scenes.updateSceneData.content, selectedName: scenes.updateSceneData.name })
        }
        else history(`/studio/${match.params.wallId}`)

        uppy.on('transloadit:result', (stepName, result) => {
            if (result.type == "video") {
                this.setState({ selectedFile: `${result.id}.${result.ext}`, previewURL: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selectedName: `video-${result.original_name}`, timeInterval: result.meta.duration })
            }
            else {
                this.setState({ selectedFile: `${result.id}.${result.ext}`, previewURL: `${UPPY_BUCKET_URL}media/tmpimages/${result.id}.${result.ext}`, selectedName: result.original_name })
            }

        })
        uppy.on('thumbnail:generated', (file, preview) => {
            const img = document.createElement('img')
            img.src = preview;
            document.getElementById("img-preview-media").src = preview;
        })
    }
    onWallSave = event => {
        const { param } = this.props;
        const { selectedFile, previewURL, selectedName, timeInterval } = this.state;
        if (selectedFile && selectedFile != null) { 
            this.setState({buttonDis:true,loader:true})
            this.props.updateRequestImage(param.contentMixId, this.props.scenes.updateSceneData.id, previewURL, previewURL, selectedName, timeInterval, this.onSaveCallBack)
        }
    }
    onBack = event => {
        const { params } = this.props.match;
        Swal.fire({
            title: "Are you sure?",
            text: "Your changes have not been saved. Do you want to save before you leave the page?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Save",
            cancelButtonText: "Discard Changes",
            reverseButtons: true,
            customClass: customClass
        }).then((result) => {
            if (result.value) {
                const { params } = this.props.match;
                const { selectedFile, previewURL, selectedName, timeInterval } = this.state;
                if (selectedFile && selectedFile != null) {
                    this.setState({buttonDis:true,loader:true})
                    this.props.updateRequestImage(params.contentMixId, this.props.scenes.updateSceneData.id, previewURL, previewURL, selectedName, timeInterval, this.onSaveCallBack)
                }
                else {
                    this.props.history(`/studio/${params.wallId}`)
                    setTimeout(() => {
                        //uppy.reset();
                        this.setState({
                            selectedFile: null,
                            selectedUrl: null,
                            selectedName: null
                        })
                    }, 2000)
                }
            }
            else if (result.dismiss === "cancel") {
                setTimeout(() => {
                    //uppy.reset();
                    this.setState({
                        selectedFile: null,
                        selectedUrl: null,
                        selectedName: null
                    })
                }, 2000)
                this.props.history(`/studio/${params.wallId}`)
            }
        });
    }
    onSaveCallBack = () => {
        const { params } = this.props.match;
        this.props.USER_STUDIO_WALL(params.wallId);
        Swal.fire({
            title: SUCCESS_TEXT,
            text: MEDIA_SUCCESS_SAVE,
            type: "success",
            icon: 'success',
            showConfirmButton: false,
            timer: 3000
        }).then((result) => {
            setTimeout(() => {
                //uppy.reset();
                this.setState({
                    selectedFile: null,
                    selectedUrl: null,
                    selectedName: null
                })
            }, 2000)
            this.setState({buttonDis:false,loader:false})
            this.props.history(`/studio/${params.wallId}`)
        })
    }
    render() {
        const { match } = this.props;
        const { selectedFile, previewURL,buttonDis,loader, selectedName } = this.state;
        return <>
            <NavigationHeader name="Media" backToNavigation={`/studio/${match.params.wallId}`} />
            <div className="container-fluid subheader_content">
                <Card className="select_wall mb-3 rounded-0 border-0">
                    <Card.Body className="p-0">
                        <Row>
                            <Col lg={4} className="border-right-lg">
                                <Card className="border-0 rounded-0">
                                    <Card.Body className="p-4 card_height">
                                        <Form>
                                            <Form.Group controlId="formBasicEmail">
                                                <Form.Label>Upload Media</Form.Label>
                                                <Dashboard //uppy dashboard component
                                                    uppy={uppy}
                                                    hideUploadButton={false}
                                                    showProgressDetails={false}
                                                    autoOpenFileEditor={false}
                                                    plugins={[
                                                        "Instagram",
                                                        "GoogleDrive",
                                                        "Url",
                                                        "Webcam"
                                                    ]}
                                                />
                                            </Form.Group>
                                        </Form>
                                    </Card.Body>
                                    <Card.Footer className="bg-transparent d-flex justify-content-end border-0 p-4">
                                        <button className="btn btn-outline-dark me-3 btn-min-w" onClick={this.onBack}><span className="position-relative">Back</span></button>
                                        <Button disabled={ buttonDis } variant="primary" className={`btn btn-primary btn-min-w ${loader ? `spinner spinner-white spinner-right disabled` : null}`} onClick={this.onWallSave}>Save</Button>
                                    </Card.Footer>
                                </Card>
                            </Col>
                            <Col lg={8} className="d-flex align-items-center justify-content-center">
                                <Card className="border-0 card w-100">
                                    <Card.Body className="border-0">
                                        <div className="wall_view">
                                            <div className="wall_view_wrapper">
                                                {
                                                    (selectedFile && previewURL) ? (selectedName && selectedName.includes("video-")) ? <video muted controls autoplay style={{ width: '100%', height: '100%' }}>
                                                        <source src={previewURL} type="video/mp4" />
                                                        <source src={previewURL} type="video/ogg" />
                                  Your browser does not support the video tag.
                              </video> : <img src={previewURL} style={{ width: '100%' }} /> : null
                                                }
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                    </Card.Body>
                </Card>
            </div>
        </>
    }

}
const mapStateToProps = state => {
    return {
        studioWall: state.studio.studioWall,
        scenes: state.scene,
    }
}
const mapDispatchToProps = dispatch => {
    return {
        updateRequestImage: (contentMixId, positionID, postFile, previewURL, name, timeInterval, callBack) => dispatch(updateRequestImage(contentMixId, positionID, postFile, previewURL, name, timeInterval, callBack)),
        USER_STUDIO_WALL: (wallID) => dispatch(USER_STUDIO_WALL(wallID))
    }
}




export default connect(mapStateToProps, mapDispatchToProps)(UpdateMedia);